import "./index.scss";
import { SellSearchItem } from "components/UI/atoms";
import { useEffect, useRef, useState } from "react";

export const SellSearchResults = ({ list, onSearchItemFocus }) => {
  const [focus, setFocus] = useState({ value: -1, type: "" });
  const searchResultsRef = useRef(null);

  const onSearchItemHover = (index) =>
    setFocus({ value: index, type: "hover" });

  useEffect(() => {
    const handleKeyDown = (event) => {
      const isNavigationKey =
        event.key === "ArrowDown" ||
        event.key === "ArrowUp" ||
        event.key === "Enter" ||
        event.key === "NumpadEnter";

      if (!isNavigationKey) return;

      event.preventDefault();

      const MIN_INDEX = 0;
      const MAX_INDEX = list.length - 1;

      if (event.key === "ArrowDown") {
        setFocus(({ value: prevFocus }) => ({
          value: prevFocus < MAX_INDEX ? prevFocus + 1 : MAX_INDEX,
          type: "arrow"
        }));
      }

      if (event.key === "ArrowUp") {
        setFocus(({ value: prevFocus }) => ({
          value: prevFocus > MIN_INDEX ? prevFocus - 1 : MIN_INDEX,
          type: "arrow"
        }));
      }

      if (event.key === "Enter" || event.key === "NumpadEnter")
        onSearchItemFocus(null, true);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [list, onSearchItemFocus]);

  useEffect(() => {
    const listItem = searchResultsRef.current.children[focus.value];

    if (listItem && focus.type === "arrow") {
      const value = listItem.attributes.name.value;

      onSearchItemFocus(value);
      listItem.scrollIntoView({
        block: "nearest",
        inline: "start"
      });
    }
  }, [focus, onSearchItemFocus]);

  return (
    <ul className="search-results" ref={searchResultsRef}>
      {list.map((brand, index) => (
        <SellSearchItem
          key={brand.id}
          focused={focus.value === index}
          onClick={onSearchItemFocus}
          onHover={() => onSearchItemHover(index)}
          {...brand}
        />
      ))}
    </ul>
  );
};
